<template lang="pug">
  main
    // Left panel content
    h1 Tour the Circuits 1 Course
    aside(class="sidebar courses-available")
      div(class="youtube-container")
        iframe(width="420" height="237" src="https://www.youtube.com/embed/EiXSvr6JwjM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
      h2 Course Sign-up Location:
      p <a href="https://circuits1.hvullc.com/"><strong>Circuits 1</strong>: Introduction to Electrical Circuits</a> taught by Tim Hanshaw (currently this course is offered at no charge)

    // Right panel content
    div(class="course-container")
      section(class="main-container just-text")
        div
          h2 More about what to expect in Circuits 1
          p This course is an introduction to the analysis of engineering systems, in which the systems of interest are all electric circuits.  Engineering analysis is an opportunity to finally apply the hard-earned mathematical skills you’ve acquired in your algebra, trigonometry, and calculus courses.  The application of these skills can be disconcerting at first, since the emphasis in engineering analysis is more related to writing the equations governing a system, rather than solving a given equation.  To add to the confusion, there is generally not a single “correct” set of equations that describe a system – there are typically several appropriate approaches.
          
          p To master engineering analysis, it is essential to understand multiple modeling approaches and choose an appropriate approach for the problem at hand.  This skill, of course, requires a different mindset from a typical mathematics class.  To support this change in mindset, practicing problem solving and seeing multiple examples of different solutions approaches is crucial.  To this end, a variety of learning materials are provided in this course:
          ol
            li Video lectures provide essential concepts and examples.
            li Reference materials provide written materials, expand on some concepts beyond the video lectures, and provide additional examples.
            li Additional examples are provided in the “Examples” link; solutions to these examples are provided in video or written form, or both.
            li Solving problems is crucial to understand the analysis approaches.  To support this, practice problems are provided that allow students to interactively solve problems and get immediate feedback relative to their understanding.  To reduce frustration, students can elect to receive hints or see the solution with a “Give up” option.  Help with multi-step problems provides prompts for intermediate solution steps to assist students to identify problem solving strategies.  Practice problems also provide links to similar examples or related materials to provide ready access to supporting materials.
            li Finally, “quizzes” allow students to test their understanding by solving problems in the absence of the ability to get assistance or “give up”.

          p To learn more, read the following:
          ul
            li
              a(href="https://hvu-s3.s3-us-west-1.amazonaws.com/Lesson0.1_text.pdf") Complete Course Overview and Preface (PDF) from the HVU Circuits 1 course
            li
              a(href="https://hvu-s3.s3-us-west-1.amazonaws.com/Lesson0.2_text.pdf") Site tour: student view document (PDF)
</template>

<script>
export default {
  name: "CoursesCircuits1"
};
</script>

<style>
.youtube-container iframe {
  width: 100%;
}
</style>
